<template>
  <div class="sso-loading">
    <div v-if="error" class="sso-error">
      <i class="el-icon-warning"></i>
      <p>{{ error }}</p>
      <el-button type="primary" size="small" @click="goBack">返回重试</el-button>
    </div>
    <div v-else class="sso-ing">
      <i class="el-icon-loading"></i>
      <p>正在登录，请稍候...</p>
    </div>
  </div>
</template>
<!--文件一：src/views/SsoCallback.vue-->
<!--这是单点登录的"落地页"，移动云跳过来后先到这个页面-->

<script>
export default {
  name: 'SsoCallback',
  data() {
    return {
      error: ''
    }
  },
  created() {
    this.handleSso()
  },
  methods: {
    async handleSso() {
      // 从 URL 里取出移动云传来的参数
      // hash模式下 URL 长这样：https://你的域名/#/sso?code=xxx&userid=xxx&eid=xxx&appId=xxx
      // 用 this.$route.query 就能直接拿到
      const { code, userid, eid, appId } = this.$route.query

      if (!code) {
        this.error = '缺少授权码，请从移动云工作台重新进入'
        return
      }

      try {
        // 把 code 发给后端换取本系统登录 token
        const res = await this.$api.post('/api/saas/sso', {
          code,
          userid: userid || '',
          eid:    eid    || '',
          appId:  appId  || ''
        })

        if (res.code === 1) {
          

          // 存到 localStorage（或你们项目里统一的存储方式）
          localStorage.setItem('token', res.data.userinfo.token)
            localStorage.setItem('userInfo',JSON.stringify(res.data.userinfo))
            this.$store.commit('setUserInfo', res.data.userinfo); // 存储用户信息到 Vuex
        //   localStorage.setItem('token',    token)
        //   localStorage.setItem('userid',   uid)
        //   localStorage.setItem('nickname', nickname)
        //   localStorage.setItem('avatar',   avatar  || '')
        //   localStorage.setItem('isadmin',  isadmin || 0)
        //   localStorage.setItem('company',  company || '')

          // 如果你用了 vuex，这里同步写入 store
          // this.$store.commit('user/SET_TOKEN', token)
          // this.$store.commit('user/SET_USER', res.data.data)

          // 登录成功，跳转到首页（或之前想去的页面）
          const redirect = this.$route.query.redirect || '/'
          this.$router.replace(redirect)

        } else {
          this.error = res.msg || '登录失败'
        }

      } catch (e) {
        console.error('[SSO] 请求失败', e)
        this.error = '网络异常，请稍后重试'
      }
    },

    goBack() {
      // 引导用户回到移动云工作台重新点击
      window.history.back()
    }
  }
}
</script>

<style scoped>
.sso-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  flex-direction: column;
  color: #606266;
}
.sso-ing i, .sso-error i {
  font-size: 40px;
  margin-bottom: 16px;
}
.sso-ing i  { color: #409EFF; }
.sso-error i { color: #F56C6C; }
.sso-error p { margin-bottom: 16px; }
</style>